// extracted by mini-css-extract-plugin
export default {"root":"Label_root__rECfK"};